(function () {
    const ua = navigator.userAgent;
    const body = document.body;

    // Detecting browsers
    const browsers = [
        { name: 'edge', pattern: /Edg/i },
        { name: 'chrome', pattern: /Chrome|CriOS/i },
        { name: 'safari', pattern: /Safari/i },
        { name: 'firefox', pattern: /Firefox|FxiOS/i },
        { name: 'opera', pattern: /OPR|Opera/i },
        { name: 'ie', pattern: /MSIE|Trident/i },
    ];

    // Detect operating systems
    const osList = [
        { name: 'windows', pattern: /Windows/i },
        { name: 'macos', pattern: /Macintosh|Mac OS X/i },
        { name: 'linux', pattern: /Linux/i },
        { name: 'android', pattern: /Android/i },
        { name: 'ios', pattern: /iPhone|iPad|iPod/i },
    ];

    // Helper function to add class
    function addClass(name) {
        if (name) body.classList.add(name);
    }

    // Match browser and OS
    browsers.forEach((browser) => {
        if (ua.match(browser.pattern)) addClass(`browser-${browser.name}`);
    });

    osList.forEach((os) => {
        if (ua.match(os.pattern)) addClass(`os-${os.name}`);
    });

    // Fallback for generic mobile detection
    if (/Mobile/i.test(ua)) addClass('device-mobile');
    if (/Tablet/i.test(ua)) addClass('device-tablet');
    if (!/Mobile|Tablet/i.test(ua)) addClass('device-desktop');
})();
